import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/hosting/cloud-hosting")({ beforeLoad: redirectTo("/hosting/vps-cloud") });
